"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchFieldsQueryBuilderPlugin = exports.SearchFieldsQueryBuilder = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const ColumnsSelector_1 = require("../selectors/ColumnsSelector");
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const SearchFieldsQueryBuilder = props => {
    const { andIndex, orIndex, params } = props;
    const vertical = true;
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    // only allow columnMaps without plugins since the
    // columns are not accessible in the where clause
    const options = queryManager.queryAliasColumnMap.filter(columnMap => !columnMap.plugin);
    const selected = options.filter(columnMap => {
        var _a;
        return columnMap.path && ((_a = params === null || params === void 0 ? void 0 : params.paths) === null || _a === void 0 ? void 0 : _a.includes(columnMap.path));
    });
    const update = (updateParams) => {
        queryManager.updatePluginCondition(andIndex, orIndex, {
            pluginType: exports.SearchFieldsQueryBuilderPlugin.type,
            conditionType: 'SearchFilter',
            params: Object.assign(Object.assign({}, params), updateParams)
        });
    };
    return (react_1.default.createElement(lab_1.Autocomplete, { multiple: true, fullWidth: true, value: selected, options: options, getOptionLabel: option => (0, ColumnsSelector_1.getEntityColumnDisplay)(option, vertical), onChange: (_, options) => {
            const paths = [];
            for (const option of options) {
                option.path && paths.push(option.path);
            }
            update({ paths });
        }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', label: 'Fields', variant: 'outlined', placeholder: 'Select Fields to search' }))) }));
};
exports.SearchFieldsQueryBuilder = SearchFieldsQueryBuilder;
exports.SearchFieldsQueryBuilderPlugin = {
    name: 'Search Fields',
    type: 'SearchFields',
    description: 'Filter fields via the search box.',
    conditions: [
        {
            name: 'Search Filter',
            type: 'SearchFilter',
            component: exports.SearchFieldsQueryBuilder
        }
    ]
};
//# sourceMappingURL=SearchFieldsQueryBuilderPlugin.js.map